import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Stepper from "./stepper";
import configData from "../../config.json"

function Question() {
  return (
    <motion.main
      className="main__container"
      initial={{ width: 0 }}
      animate={{ width: "100%" }}
      exit={{ x: "100%", opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Stepper step="1"></Stepper>
      <section className="text-center container-fluid mb-5">
        
        <div className="row h-100 mt-5">
          <h1>¿Qué tipo de identificación tenés?</h1>
        </div>
        <div className="row pt-5 pb-5">
          <div className="pt-2 offset-lg-2 col-lg-3 offset-sm-1 col-sm-10 text-center">
            <a className="btn btn-lg w-100 btn-red" href={configData.INFO_LINKS.LANDING}>Extranjero</a>
          </div>
          <div className="pt-2 offset-lg-2 col-lg-3 offset-sm-1  col-sm-10 text-center">
            <Link className="btn btn-lg w-100 btn-yellow" to="/information/identify">Nacional</Link>
          </div>
        </div>
      </section>
    </motion.main>
  )
}

export default Question